import React from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {AuthProvider} from "./features/auth/contexts/auth-context";
import {LoadingProvider} from "./features/core/contexts/loading-context";
import AppInitDependencies from "./app-init-dependencies";
import {ModalProvider} from "@common/contexts/modal-context";

const router = createBrowserRouter([
    {
        path: '*',
        element: (
            <AuthProvider>
                <ModalProvider>
                    <AppInitDependencies/>
                </ModalProvider>
            </AuthProvider>
        ),
    },
]);

function App() {
    return (
        <LoadingProvider>
            <RouterProvider router={router}/>
        </LoadingProvider>
    )
}

export default App;
